import { BinaryOption } from '../enums';
export const getYesNoOptions = () => {
    return [
        { name: 'Yes', value: BinaryOption.TRUE },
        { name: 'No', value: BinaryOption.FALSE },
    ];
};
export const getCriteriaYesNoOptions = () => {
    return [
        { name: 'Yes', value: BinaryOption.TRUE },
        { name: 'No', value: BinaryOption.FALSE },
        { name: 'Both', value: 'Both' },
    ];
};
